import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";

interface FooterQuickLinksProps {
  onNavigate: (hash: string) => void;
}

const FooterQuickLinks = ({ onNavigate }: FooterQuickLinksProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  const handleClick = (e: React.MouseEvent, hash: string) => {
    e.preventDefault();

    if (isHomePage) {
      // We're already on the homepage, just scroll to the element
      onNavigate(hash);
    } else {
      // Navigate to the homepage first and then scroll
      navigate("/", { state: { noRedirect: true } });

      // Give the page time to load before scrolling
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  return (
    <div>
      <h3 className="font-bold mb-4 text-lg">Quick Links</h3>
      <ul className="space-y-2">
        <li>
          <Link
            to="/about"
            className="text-white hover:text-white/80 transition-colors"
          >
            About NationCard™
          </Link>
        </li>
        <li>
          <a
            href="/#how-it-works"
            className="text-white hover:text-white/80 transition-colors"
            onClick={(e) => handleClick(e, "#how-it-works")}
          >
            How It Works
          </a>
        </li>
        <li>
          <Link
            to="/solutions/verified-pollsters"
            className="text-white hover:text-white/80 transition-colors"
          >
            Become a Pollster
          </Link>
        </li>
        <li>
          <Link
            to="/partners"
            className="text-white hover:text-white/80 transition-colors"
          >
            Join Partner Network
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default FooterQuickLinks;
